<template>
  <div>
    <highcharts :options="mergedOptions" ref="chart" :key="key"></highcharts>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import stockInit from 'highcharts/modules/stock'
exportingInit(Highcharts)
stockInit(Highcharts)

const langMap = {
  en: 'https://code.highcharts.com/i18n/lang.json',
  fr: 'https://code.highcharts.com/i18n/fr-FR.json'
}

export default {
  name: 'UiHighCharts',
  data () {
    return {
      key: 0,
      currentLang: {}
    }
  },
  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    mergedOptions() {
      return {
        ...this.options,
        lang: this.currentLang // merge lang vào options
      }
    }
  },
  watch: {
    options: function (news, old) {
      this.key = Math.random()
    },
    '$i18n.locale': {
      immediate: true,
      handler(newLocale) {
        const url = langMap[newLocale]
        const fetchLang = async () => {
          const langOptions = await fetch(url)
            .then(response => response.json())
          this.currentLang = langOptions
          this.key = Math.random()
        }
        fetchLang()
      }
    }
  },
  mounted() {
    // set lang mặc định lúc đầu
    this.$watch('$i18n.locale', () => {}, { immediate: true })
  }
}

</script>
